'use client'

import { useNavigate } from 'react-router-dom'
import { LoadingState } from '@repo/ui/LoadingState'
import { useEffect } from 'react'
import MUIStack from '@mui/material/Stack'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useUrlStore } from '@repo/store/useUrlStore'

const Logout = () => {
  const navigate = useNavigate()
  const { logout, isLoggedIn, iframeIsLoggedIn } = useAuthenticationStore()
  const { setIframeSrc } = useUrlStore()
  const { isLocal } = useGlobalSettingsStore()

  useEffect(() => {
    const doLogout = async () => {
      // this will clear the contents of all stores, including the authentication store
      await logout()
    }

    if (iframeIsLoggedIn) {
      console.log('setting iframe src to logout.aspx')
      setIframeSrc('logout.aspx')
    }

    if (!iframeIsLoggedIn && isLoggedIn) {
      console.log('logging out of react')
      doLogout()
    }

    if (!isLoggedIn && (!iframeIsLoggedIn || isLocal)) {
      console.log('navigating to login page')
      navigate('/auth/login')
    }
  }, [navigate, logout, isLoggedIn, iframeIsLoggedIn, setIframeSrc, isLocal])

  return (
    <MUIStack direction="row" justifyContent="center" alignItems="center" sx={{ height: '100%', width: '100%' }}>
      <LoadingState />
    </MUIStack>
  )
}

export default Logout
